import React from "react";
import "../CSS/DeliveryBanner.css";

const DeliveryBanner = () => {
    return (
        <div className="delivery-banner">
            <p className="delivery-banner-text"> Secure your delivery slot by pre-ordering your arrangement 3-4 days in advance. </p>
            <p className="delivery-banner-text"> Happy shopping! </p>
        </div>
    );
};

export default DeliveryBanner;